import { buildAnimal } from './indicator.ts';

/**
 * /version.json, published with every build: the build ID and its beta indicator (colour + animal).
 * Open pages compare it with the build they run (src/pwa/register.ts `checkVersion`).
 */
export interface VersionFile {
  buildId: string;
  /** Beta build indicator (src/build/indicator.ts); remove at public launch. */
  build: { id: string; emoji: string; name: string; background: string; text: string };
}

export function versionFile(buildId: string): VersionFile {
  const { id, emoji, name, background, text } = buildAnimal(buildId);
  return { buildId, build: { id, emoji, name, background, text } };
}

/** The build part's timestamp ("20261011-0022"), comparable as text; undefined for an ID without one. */
const stamp = (buildId: string): string | undefined => /\+(\d{8}-\d{4})-/.exec(buildId)?.[1];

/** Whether `other` is a newer build than `running` (by build time; a different ID at the same minute counts as newer). */
export function isNewerBuild(other: string, running: string): boolean {
  if (other === running) return false;
  const a = stamp(other);
  const b = stamp(running);
  if (!a || !b) return false;
  return a >= b;
}
